import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
const buttonClass = 'sm:inline-flex justify-center rounded-md border py-2 px-4 text-sm font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 sm:w-auto w-full block';
const primaryButtonClass = 'bg-green-600 hover:bg-green-700 focus:ring-green-500 text-white border-transparent';
const secondaryButtonClass = 'bg-gray-200 hover:bg-gray-300 text-gray-700 border-transparent';
const darkGrayClass = 'text-white bg-gray-800 hover:bg-gray-900';
const defaultClass = 'border-gray-300 bg-white text-gray-700 hover:text-gray-500';
const redButtonClass = 'bg-red-600 hover:bg-red-700 focus:ring-red-500 text-white border-transparent';
function getColorClass(color) {
    if (color === 'green') {
        return primaryButtonClass;
    }
    if (color === 'darkGray') {
        return darkGrayClass;
    }
    if (color === 'gray') {
        return secondaryButtonClass;
    }
    if (color === 'red') {
        return redButtonClass;
    }
    return defaultClass;
}
export default function Button({ children, type, href, onClick, color, className, disabled = false, testDataId, dataTestId }) {
    const finalClassName = classnames(buttonClass, getColorClass(color), className, disabled ? 'disabled' : '');
    if (href) {
        return (React.createElement(Link, { href: href, className: finalClassName }, children));
    }
    return (React.createElement("button", { type: type, onClick: onClick, className: finalClassName, disabled: disabled, "data-testid": testDataId || dataTestId || 'button' }, children));
}
Button.propTypes = {
    actionLabel: PropTypes.string,
    color: PropTypes.string,
    children: PropTypes.node,
    type: PropTypes.string,
};
Button.defaultProps = {
    children: React.createElement("span", { "data-testid": "span-13f5b2e8" }, "Save"),
    color: '',
    type: 'button',
};
